/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stale_Reload_TitleInputs */

const en_stale_reload_title = /** @type {(inputs: Stale_Reload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version of Bystep was deployed`)
};

const id_stale_reload_title = /** @type {(inputs: Stale_Reload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep versi baru sudah dipasang`)
};

/**
* | output |
* | --- |
* | "A new version of Bystep was deployed" |
*
* @param {Stale_Reload_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const stale_reload_title = /** @type {((inputs?: Stale_Reload_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stale_Reload_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stale_reload_title(inputs)
	return en_stale_reload_title(inputs)
});